import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';

import {
	Input,
	InputType,
	SpinnerOverlay,
	SubmissionButtons,
} from '@components/common';

import { useMutateDisable2Fa } from '@hooks/userProfile/useMutateDisable2Fa';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { IResponseError } from '@interfaces/errors/apiErrors';
import { IDisable2FAValueDTO } from '@interfaces/user/dto/userProfileDTO';

import { ESnackbarTypes } from '@enums/common';
import { Disable2FA } from '@enums/userProfile';
import { ERevalidationMode, EValidationMode } from '@enums/validationMode';

import { responseMessages } from '@constants/responseMessages';

import { schema } from './schema';

interface IConfirm2FaProps {
	onClose: () => void;
}

const Confirm2Fa = ({ onClose }: IConfirm2FaProps) => {
	const dispatch = useAppDispatch();

	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
		setError,
	} = useForm<IDisable2FAValueDTO>({
		mode: EValidationMode.all,
		reValidateMode: ERevalidationMode.onChange,
		resolver: yupResolver(schema),
		defaultValues: {
			[Disable2FA.password]: '',
		},
	});

	const onSuccess = () => {
		dispatch(setSnackbar({
			message: responseMessages.disable2Fa,
			type: ESnackbarTypes.success,
		}));

		onClose();
	};

	const onError = (err: IResponseError) => {
		if (!err.errors[0].message) return;

		setError(Disable2FA.password, {
			message: (err.errors[0].message),
		});
	};

	const { disable2Fa, isLoadingDisable2Fa } = useMutateDisable2Fa({
		onSuccess,
		onError,
	});

	const onSubmit = (values: IDisable2FAValueDTO) => disable2Fa({ password: values[Disable2FA.password] });

	return (
		<div>
			{isLoadingDisable2Fa && <SpinnerOverlay />}
			<div>
				Please provide your current password for verification
			</div>
			<br />
			<div>
				<div>
					<Input
						errorMessage={errors?.password?.message}
						label='Current password'
						name={Disable2FA.password}
						placeholder='Enter password'
						register={register}
						required
						setValue={setValue}
						type={InputType.password}
					/>
				</div>
				<SubmissionButtons
					disabledPositive={!!errors?.password?.message}
					negativeHandler={onClose}
					positiveHandler={handleSubmit(onSubmit)}
					positiveLabel='Confirm'
				/>
			</div>
		</div>
	);
};

export default Confirm2Fa;
